import { Phone, FileText, Home, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
    {
        icon: Phone,
        title: "Vous nous contactez",
        text: "Par téléphone. Nous recueillons les informations nécessaires.",
    },
    {
        icon: FileText,
        title: "Nous contactons votre assurance",
        text: "Nous vous accompagnons dans toutes les démarches administratives.",
    },
    {
        icon: Home,
        title: "Intervention rapide",
        text: "À domicile ou sur votre lieu de travail, efficace et propre.",
    },
    {
        icon: Check,
        title: "Vous roulez en toute sécurité",
        text: "Votre nouveau pare-brise est posé, étanche et garanti à vie.",
    },
];

export const HowItWorks = () => (
    <section
        data-testid="how-it-works-section"
        className="relative py-28 bg-midnight-800 diagonal-gold-lines border-y border-white/5 overflow-hidden"
    >
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <Reveal className="text-center max-w-2xl mx-auto">
                <span className="text-xs font-semibold tracking-[0.3em] uppercase text-gold">
                    Notre méthode
                </span>
                <h2 className="mt-4 font-display font-extrabold uppercase tracking-wide text-3xl sm:text-4xl text-white">
                    Comment ça marche ?
                </h2>
                <span className="mt-6 mx-auto block h-px w-24 bg-gradient-to-r from-transparent via-gold to-transparent" />
            </Reveal>

            <ol className="mt-20 grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative">
                <span
                    className="hidden md:block absolute top-9 left-[12%] right-[12%] border-t border-dashed border-gold/30"
                    aria-hidden="true"
                />
                {STEPS.map((step, i) => (
                    <Reveal key={step.title} delay={i * 0.14} className="relative">
                        <li data-testid={`timeline-step-${i}`} className="group flex md:flex-col items-start md:items-center gap-5 md:gap-0 md:text-center">
                            <span className="relative z-10 flex items-center justify-center w-[4.5rem] h-[4.5rem] shrink-0 rounded-full border border-gold/50 bg-midnight-900 text-gold shadow-[0_0_30px_rgba(212,175,55,0.2)] transition-[transform,box-shadow] duration-500 group-hover:scale-110 group-hover:shadow-[0_0_45px_rgba(212,175,55,0.4)]">
                                <step.icon size={24} strokeWidth={1.75} />
                                <span className="absolute -top-2 -right-2 flex items-center justify-center w-7 h-7 rounded-full bg-gradient-to-br from-gold-light to-gold-dark text-[11px] font-bold text-midnight-900">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </span>
                            <div className="md:mt-7">
                                <h3 className="font-display font-semibold text-xl text-gold-light leading-snug">
                                    {step.title}
                                </h3>
                                <p className="mt-2 text-sm text-gray-400 leading-relaxed md:max-w-[15rem] md:mx-auto">
                                    {step.text}
                                </p>
                            </div>
                        </li>
                    </Reveal>
                ))}
            </ol>
        </div>
    </section>
);
